export default "__VITE_ASSET__CaiVL1v5__"